<div class="dialog-title">Unit Setup</div>

<mat-form-field>
  <input
    matInput
    placeholder="Upload Excel Template"
    readonly
    (click)="fileInput.click()"
    [(ngModel)]="fileName"
  />
  <mat-icon matSuffix>publish</mat-icon>
</mat-form-field>
<input
  type="file"
  name="pic"
  style="display: none"
  (change)="fileChangeEvent($event)"
  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
  #fileInput
/>

<mat-radio-group *ngIf="displayMethods" aria-label="Select an option" class="full-width" [(ngModel)]="selectedMethod">
  <section>
    <mat-radio-button value="O" [disabled]="!allowOverwrite">
      <div class="xsTitle-f">Overwrite</div>
      <div class="xsDesc-f show-overflow">
        Clear all uploaded units. Only applicable when there is no transaction performed.
      </div>
    </mat-radio-button>
  </section>
  <section>
    <mat-radio-button value="A" [disabled]="!allowAppend">
      <div class="xsTitle-f">Append</div>
      <div class="xsDesc-f">Upload additional units.</div>
    </mat-radio-button>
  </section>
  <section>
    <mat-radio-button value="M">
      <div class="xsTitle-f">Modify</div>
      <div class="xsDesc-f show-overflow">
        Edit uploaded units details except for built up area and price.
      </div>
    </mat-radio-button>
  </section>
</mat-radio-group>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" (click)="uploadExcel()">Upload</button>
</div>
